const actionsPanelActions = {
  UPDATE_ACTIONS_PANEL_REQUEST: 'UPDATE_ACTIONS_PANEL_REQUEST',
};

export default actionsPanelActions;
